var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.headerWithSignature
    ? _c("h2", { domProps: { innerHTML: _vm._s(_vm.headerWithSignature) } })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }